module.exports = __webpack_public_path__ + "img/waxweth_eth.token.eb87cb2.png";